import { render, staticRenderFns } from "./ArtisanCalendar.vue?vue&type=template&id=29edae4c&scoped=true"
import script from "./ArtisanCalendar.vue?vue&type=script&lang=js"
export * from "./ArtisanCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29edae4c",
  null
  
)

export default component.exports